// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispute-export-button mat-icon {
  margin-right: 4px;
}

.dispute-export-status {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/dispute-export-button/dispute-export-button.component.scss"],"names":[],"mappings":"AAEE;EACE,iBAAA;AADJ;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;AALF","sourcesContent":[".dispute-export-button {\r\n  // Matches the icon/label spacing of the sibling action buttons in the DR views.\r\n  mat-icon {\r\n    margin-right: 4px;\r\n  }\r\n}\r\n\r\n// Available to assistive technology, absent from the visual layout. Defined here rather than\r\n// borrowing `cdk-visually-hidden` so the class is guaranteed to have a matching rule in a\r\n// stylesheet this component actually loads.\r\n.dispute-export-status {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0 0 0 0);\r\n  clip-path: inset(50%);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
